// A set of parameters that control the rendering of the world.

export default class Environment {
  constructor() {
    this.pedestrians = 0;
    this.bikes = 0;
    this.cargoBikes = 0;
    this.cars = 0;
    this.trucks = 0;
    this.buses = 0;
    this.passengerTrains = 0;
    this.freightTrains = 0;
    this.boats = 0;
  }
}
